import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../styles/auth.css';

const VerifyOTP = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const email = location.state?.email || '';

  const [otp, setOtp] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleVerify = async (e) => {
    e.preventDefault();

    if (!otp) {
      setMessage('Please enter your OTP');
      return;
    }

    try {
      setLoading(true);
      setMessage('');

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/auth/verify-otp`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            email,
            otp
          })
        }
      );

      const data = await response.json();

      if (!response.ok) {
        setMessage(data.message || 'OTP verification failed');
        return;
      }

      setMessage('Email verified successfully');

      setTimeout(() => {
        navigate('/login');
      }, 1000);

    } catch (error) {
      setMessage('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <form onSubmit={handleVerify} className="auth-form">
        <h2>Verify Your Email</h2>

        <p>
          Enter the OTP sent to:
        </p>

        <p>
          {email}
        </p>

        <input
          type="text"
          placeholder="Enter 6-digit OTP"
          value={otp}
          onChange={(e) => setOtp(e.target.value.replace(/\D/g, ''))}
          maxLength="6"
          inputMode="numeric"
          required
        />

        <button type="submit" className="btn" disabled={loading}>
          {loading ? 'Verifying...' : 'Verify OTP'}
        </button>

        {message && <p>{message}</p>}
      </form>
    </div>
  );
};

export default VerifyOTP;